import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0caefa94"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "buttonText" }, "Back", -1))
const _hoisted_3 = {
  key: 0,
  class: ""
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "buttonText" }, "View country", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "buttonText" }, "Back", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "buttonText" }, "View country", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_country_picker = _resolveComponent("country-picker")!
  const _component_country_name_bar = _resolveComponent("country-name-bar")!
  const _component_industry_performance_scores = _resolveComponent("industry-performance-scores")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_compare_countries_button = _resolveComponent("compare-countries-button")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "industryPerformance pl-0" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          (!_ctx.isMobile)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: _ctx.comparisonMode ? 6 : 12,
                class: "d-flex flex-column"
              }, {
                default: _withCtx(() => [
                  (_ctx.comparisonMode)
                    ? (_openBlock(), _createBlock(_component_country_picker, {
                        key: 0,
                        class: "country-picker_on_industryPerformance",
                        onSelectedCountry: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateMainCountry($event))),
                        initialCountry: _ctx.mainCountry
                      }, null, 8, ["initialCountry"]))
                    : _createCommentVNode("", true),
                  (!_ctx.comparisonMode)
                    ? (_openBlock(), _createBlock(_component_country_name_bar, {
                        key: 1,
                        countryName: _ctx.mainCountry.country_name,
                        class: "pb-12 pl-4"
                      }, null, 8, ["countryName"]))
                    : _createCommentVNode("", true),
                  (_ctx.mainCountry && _ctx.mainCountry.industryPerformance)
                    ? (_openBlock(), _createBlock(_component_industry_performance_scores, {
                        country: _ctx.mainCountry,
                        key: _ctx.mainCountry.iso + _ctx.comparisonMode,
                        comparisonMode: _ctx.comparisonMode,
                        sharedPage: _ctx.sharedPage,
                        onPageChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sharedPage = $event)),
                        duplicate: _ctx.comparisonCountry.industryPerformance,
                        singleCompare: _ctx.singleCompare,
                        class: _normalizeClass(_ctx.comparisonMode ? 'comparisonPerformance' : '')
                      }, null, 8, ["country", "comparisonMode", "sharedPage", "duplicate", "singleCompare", "class"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["cols"]))
            : _createCommentVNode("", true),
          (_ctx.comparisonMode && !_ctx.isMobile)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 1,
                cols: 6,
                class: "d-flex flex-column"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_country_picker, {
                    class: "country-picker_on_industryPerformance",
                    onSelectedCountry: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateComparisonCountry($event)))
                  }),
                  (_ctx.comparisonCountry && _ctx.comparisonCountry.industryPerformance)
                    ? (_openBlock(), _createBlock(_component_industry_performance_scores, {
                        key: 0,
                        country: _ctx.comparisonCountry,
                        comparisonMode: true,
                        sharedPage: _ctx.sharedPage,
                        onPageChanged: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sharedPage = $event)),
                        class: _normalizeClass(_ctx.comparisonMode ? 'comparisonPerformance' : '')
                      }, null, 8, ["country", "sharedPage", "class"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isMobile)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 2,
                cols: 12
              }, {
                default: _withCtx(() => [
                  (_ctx.comparisonMode)
                    ? (_openBlock(), _createBlock(_component_country_picker, {
                        key: 0,
                        class: "country-picker_on_industryPerformance",
                        onSelectedCountry: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateMainCountry($event))),
                        initialCountry: _ctx.mainCountry
                      }, null, 8, ["initialCountry"]))
                    : _createCommentVNode("", true),
                  (!_ctx.comparisonMode)
                    ? (_openBlock(), _createBlock(_component_country_name_bar, {
                        key: 1,
                        countryName: _ctx.mainCountry.country_name,
                        class: "pb-12 pl-4"
                      }, null, 8, ["countryName"]))
                    : _createCommentVNode("", true),
                  (_ctx.isMobile)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 2,
                        cols: 12
                      }, {
                        default: _withCtx(() => [
                          (_ctx.comparisonMode)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createVNode(_component_v_btn, {
                                  class: "compareBackBtn mobileCompareBackBtn",
                                  rounded: "",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeCompareMode(true)))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_2
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.mainCountry && _ctx.mainCountry.industryPerformance)
                    ? (_openBlock(), _createBlock(_component_industry_performance_scores, {
                        country: _ctx.mainCountry,
                        key: _ctx.mainCountry.iso + _ctx.comparisonMode,
                        comparisonMode: _ctx.comparisonMode,
                        sharedPage: _ctx.sharedPage,
                        onPageChanged: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sharedPage = $event)),
                        duplicate: _ctx.comparisonCountry.industryPerformance,
                        singleCompare: _ctx.singleCompare
                      }, null, 8, ["country", "comparisonMode", "sharedPage", "duplicate", "singleCompare"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.comparisonMode && _ctx.isMobile)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 3,
                cols: 12
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_country_picker, {
                    class: "country-picker_on_industryPerformance",
                    onSelectedCountry: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateComparisonCountry($event)))
                  }),
                  (_ctx.comparisonMode && _ctx.isMobile)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        cols: 12
                      }, {
                        default: _withCtx(() => [
                          (_ctx.comparisonCountry && _ctx.comparisonCountry.industryPerformance)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createVNode(_component_v_btn, {
                                  class: "compareBackBtn viewCountryBtn midnightButton buttonBranding_midnight mobileCompareBackBtn",
                                  rounded: "",
                                  flat: "",
                                  ripple: false,
                                  onClick: _ctx.viewNewCountry
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_4
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.comparisonCountry && _ctx.comparisonCountry.industryPerformance)
                    ? (_openBlock(), _createBlock(_component_industry_performance_scores, {
                        key: 1,
                        country: _ctx.comparisonCountry,
                        comparisonMode: true,
                        sharedPage: _ctx.sharedPage,
                        onPageChanged: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sharedPage = $event))
                      }, null, 8, ["country", "sharedPage"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          (!_ctx.isMobile && _ctx.comparisonMode)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: _ctx.comparisonMode ? 6 : 12,
                class: "d-flex flex-column mb-4"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_v_btn, {
                      class: "compareBackBtn midnightButton buttonBranding_midnight desktopCompareBackBtn",
                      rounded: "",
                      onClick: _ctx.changeCompareMode
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _: 1
              }, 8, ["cols"]))
            : _createCommentVNode("", true),
          (_ctx.comparisonMode && !_ctx.isMobile)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 1,
                cols: 6,
                class: "d-flex flex-column mb-4"
              }, {
                default: _withCtx(() => [
                  (_ctx.comparisonCountry && _ctx.comparisonCountry.industryPerformance)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_v_btn, {
                          class: "compareBackBtn desktopCompareBackBtn viewCountryBtn",
                          rounded: "",
                          onClick: _ctx.viewNewCountry
                        }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (!_ctx.comparisonMode)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            class: _normalizeClass(_ctx.isMobile ? 'compareCountriesButtonHolderMobile' : 'compareCountriesButtonHolder')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_compare_countries_button, { onChangeCompareMode: _ctx.changeCompareMode }, null, 8, ["onChangeCompareMode"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}